import { DataListCommunicationPreference } from "../data-list";
import { FileDocument } from "../filedocument";
import { Language } from "../language";
import { AdministrativeUnit } from "../organizations/administrative-unit";
import { School } from "../organizations/school";
import { TenantSurvey } from "../survey";
import { User } from "../user";
import { WorkflowStatus } from "../workflow";
import { CommunicationPreference } from "./lookup-models";

export interface DisputeCaseBaseDto {
  id: string;
  caseNumber: string;
  summary: string;
  dateOfReceipt?: Date;

  disputeCaseType: DisputeCaseType;

  administrativeUnitId?: string;
  administrativeUnit?: AdministrativeUnit;
  school?: School;
  schoolId?: string;
  schoolOther?: string;

  isProvidedToAu: boolean;

  spEdAuContactTitle: string;
  spEdAuContactName: string;
  spEdAuContactPhone: string;
  spEdAuContactEmail: string;

  preferredLanguage?: Language;
  preferredLanguageId?: string;
  preferredLanguageOther?: string;

  notes: string;

  currentStatus: string;
  workflowStatus: WorkflowStatus;
  workflowId: string;

  signature?: string;

  createdOn: Date;
}

export interface CreateUpdateDisputeCaseBaseDto {
  id?: string;
  caseNumber?: string;
  disputeCaseType: DisputeCaseType;
  summary?: string;
  dateOfReceipt: Date;

  administrativeUnitId?: string;
  schoolId?: string;
  schoolOther?: string;

  isProvidedToAu?: boolean;

  spEdAuContactTitle?: string;
  spEdAuContactName?: string;
  spEdAuContactPhone?: string;
  spEdAuContactEmail?: string;

  preferredLanguageId?: string;
  preferredLanguageOther?: string;

  notes?: string;

  workflowId?: string;
  currentStatus?: string;

  signature?: string;

  token?: string;
  getCopyOfRequest?: boolean;
}

export interface DisputeDocumentBaseDto {
  id?: string;
  disputeCaseId?: string;
  displayText?: string;
  url?: string;
  documentId?: string;
  document?: FileDocument;
  createdOn?: Date;
  expanded?: boolean; // Used for UI to track if the document is expanded in the list
}

export interface DisputeIssueBaseDto {
  id?: string;
  disputeCaseId?: string;
  allegedIssue?: string;
  allegedIssueSummary?: string;
  supportFacts?: string;
  supportFactsSummary?: string;
  proposedResolution?: string;
  proposedResolutionSummary?: string;
}

export interface DisputePartyBaseDto {
  id?: string;
  disputeCaseId?: string;

  firstName?: string;
  middleName?: string;
  lastName?: string;
  dateOfBirth?: Date;

  partyStateId?: string;
  partySchoolId?: string;
  grade?: string;

  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;

  email?: string;
  phone?: string;
  phone2?: string;
  fax?: string;

  relationshipId?: string;
  relationshipOther?: string;

  isFiler?: boolean;
  isRespondent?: boolean;
  isChild?: boolean;

  communicationPreference?: DataListCommunicationPreference;
  communicationPreferenceId?: string;

  tenantSurvey?: TenantSurvey;
  tenantSurveyId?: string;

  userId?: string;

  disputeDocumentParties?: DisputeDocumentPartiesDto[];
}

export interface DisputeChangeHistoryBaseDto {
  id: string;
  disputeCaseId: string;
  fromWorkflowStatus: WorkflowStatus;
  fromWorkflowStatusId: string;
  toWorkflowStatus: WorkflowStatus;
  toWorkflowStatusId: string;
  statusChangeType: string;

  createdOn?: Date;
  createdBy?: User;
  createdById?: string;
  updatedOn?: Date;
  updatedBy?: User;
  updatedById?: string;
}

export interface DisputeDocumentPartiesDto {
  disputeDocumentId?: string;
  disputePartyId?: string;
}

export interface CreateUpdateDisputeDisputeDocumentBaseDto {
  id?: string;
  disputeCaseId?: string;
  displayText?: string;
  url?: string;
  documentId?: string;
  expanded?: boolean; // Used for UI to track if the document is expanded in the list
}

export interface CreateUpdateDisputeIssueBaseDto {
  id?: string;
  disputeCaseId?: string;
  allegedIssue?: string;
  allegedIssueSummary?: string;
  supportFacts?: string;
  supportFactsSummary?: string;
  proposedResolution?: string;
  proposedResolutionSummary?: string;
}

export interface CreateUpdateDisputePartyBaseDto {
  id?: string;
  disputeCaseId?: string;

  firstName?: string;
  middleName?: string;
  lastName?: string;
  dateOfBirth?: Date;

  partyStateId?: string;
  partySchoolId?: string;
  grade?: string;

  street1?: string;
  street2?: string;
  city?: string;
  state?: string;
  zip?: string;

  email?: string;
  phone?: string;
  phone2?: string;
  fax?: string;

  relationshipId?: string;
  relationshipOther?: string;

  isFiler?: boolean;
  isRespondent?: boolean;
  isChild?: boolean;

  communicationPreferenceId?: string;

  tenantSurveyId?: string;
  tenantSurvey?: TenantSurvey;

  userId?: string;

  disputeDocumentParties?: DisputeDocumentPartiesDto[];
}

export interface DisputeCaseTypeCount {
  caseType: DisputeCaseType;
  displayName: string;
  totalCases: number;
}

export interface CaseIssueDto {
  id?: string;
  issueId: string;
  label?: string;
}

export enum DisputeCaseType {
  None = 0,
  AreaOfConcern = 1,
  DueProcess = 2,
  IEPFacilitation = 3,
  Mediation = 4,
  ParentEngagement = 5,
  StateComplaint = 6,
  EarlyDisputeResolution = 7,
}
